<template>
    <form class="">
        <div class="form-group mb-3">
          <label for="nickname">
              Nickname (Make it unique)
              <span class="text-danger">*</span>
          </label>
          <input type="text" v-validate="{required: true}" v-model="data.nickname" id="nickname" name="nickname" class="form-control"
          :class="{ 'is-invalid': errors.has('nickname') }" placeholder="Nickname" />
          <span class="text-danger invalid-feedback"  v-show="errors.has('nickname')">{{ errors.first('nickname') }}</span>
        </div>
        <div class="form-group mb-3">
            <label for="inputTitle">
                Title <span class="text-danger small">*</span>
            </label>
            <input type="text" v-validate="{ required: true}" v-model="data.title"
                id="inputTitle" name="title" class="form-control" :class="{ 'is-invalid': errors.has('title') }"
                placeholder="Enter display name" />
            <span class="text-danger small"  v-show="errors.has('title')">{{ errors.first('title') }}</span>
        </div>
        <div class="form-group mb-3">
          <label class="">Module</label>
          <select class="custom-select" v-validate="{required: true}" 
            v-model="data.model" name="model" placeholder="--select module--">
            <option disabled value="">--select module --</option>
            <option value="PRODUCT"> Product </option>
            <!-- <option value="PLAN"> Plans </option> -->
          </select>
          <span class="text-danger invalid-feedback"  v-show="errors.has('model')">{{ errors.first('model') }}</span>
        </div>
        <div class="form-group mb-3">
            <label class="form-label" for="description">Description</label>
            <textarea id="description"
                v-model="data.description" class="form-control" rows="2"
                placeholder="Write description" name="description"></textarea>
        </div>
        <div class="d-flex mt-3 justify-content-end">
          <b-button variant="primary" @click.prevent="editMode? update() : create()" type="button">{{editMode? 'Update':'Submit'}}</b-button>
        </div>
    </form>
</template>

<script>
export default {
    props:{
        editItem:{
            type: Object,
            default: null
        },
        editMode:{
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            data: {
                nickname: "",
                title: "",
                description: "",
                model: "PRODUCT",
            },
        }
    },
    methods:{
        create() {
            this.$validator.validateAll().then(result => {
                if (!result) {this.alertError("Form not valid"); return }
                const formData = new FormData()
                this.$store.dispatch("changeLoaderValue", true)
                formData.append('data', JSON.stringify(this.data))
                this.$http.post("/requirement-sections/create", formData)
                .then((response) => {
                    this.$store.dispatch("changeLoaderValue", false)
                    if(response.data.success){
                        this.$store.commit("section/ADD_ITEM", response.data.data)
                        this.resetForm();
                    }
                })
            })
        },
        update(){
           this.$validator.validateAll().then(result => {
                if (!result) {this.alertError("Form not valid"); return }
                const formData = new FormData()
                this.$store.dispatch("changeLoaderValue", true)
                formData.append('data', JSON.stringify(this.data))
                this.$http.post(`/requirement-sections/${this.editItem.id}/update`,formData)
                .then((response) => {
                    this.$store.dispatch("changeLoaderValue", false)
                    if(response.data.success){
                        this.$store.commit("section/UPDATE_ITEM", response.data.data)
                        this.resetForm()
                    }
                })
            
            })
        },
        resetForm(){
            this.$validator.reset()
            this.$emit("closeMe")
        }
    },
    mounted(){
        if(this.editMode){
            this.data = this.$options.filters
                        .patchUpdatables(this.data, this.editItem)
        }
    }
}
</script>

<style>

</style>